/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const OrderStatusEnum = {
    pending: 'pending',
    in_progress: 'in_progress',
    ready: 'ready',
    delivered: 'delivered',
    rejected: 'rejected',
    pick_up_by_driver: 'pick_up_by_driver',
    preorder: 'preorder',
    accept_by_driver: 'accept_by_driver',
    parked: 'parked',
    refunded: 'refunded',
    draft: 'draft'
} as const;

export type OrderStatusEnum = typeof OrderStatusEnum[keyof typeof OrderStatusEnum];



